import { unwrapEnvelopeData } from '@/utils/parseAuthEnvelope';

/**
 * Chuẩn hóa danh sách từ BE: envelope `{ data }`, mảng thuần, hoặc `{ items|data|results }`.
 */
export function unwrapOpsList<T = Record<string, unknown>>(raw: unknown): T[] {
  const inner = unwrapEnvelopeData<unknown>(raw);
  if (Array.isArray(inner)) return inner as T[];
  if (inner && typeof inner === 'object') {
    const o = inner as Record<string, unknown>;
    if (Array.isArray(o.items)) return o.items as T[];
    if (Array.isArray(o.data)) return o.data as T[];
    if (Array.isArray(o.results)) return o.results as T[];
  }
  if (Array.isArray(raw)) return raw as T[];
  return [];
}

/** Một object từ envelope hoặc body trần. */
export function unwrapOpsObject<T = Record<string, unknown>>(raw: unknown): T | null {
  const inner = unwrapEnvelopeData<unknown>(raw);
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) return inner as T;
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) return raw as T;
  return null;
}

/** Phản hồi phân trang `{ items, total, page, pageSize }` sau envelope. */
export function unwrapOpsPaginated<T>(raw: unknown): {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
} {
  const inner = unwrapOpsObject<Record<string, unknown>>(raw);
  if (!inner) {
    return { items: [], total: 0, page: 1, pageSize: 20 };
  }
  const items = Array.isArray(inner.items) ? (inner.items as T[]) : [];
  return {
    items,
    total: typeof inner.total === 'number' ? inner.total : Number(inner.total ?? 0),
    page: typeof inner.page === 'number' ? inner.page : Number(inner.page ?? 1),
    pageSize: typeof inner.pageSize === 'number' ? inner.pageSize : Number(inner.pageSize ?? 20),
  };
}
